import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m2.758 12.917 6.65-6.371c.19-.188.399-.296.608-.296s.416.077.577.233l6.65 6.37a.83.83 0 0 1 .024 1.18.83.83 0 0 1-1.18.025l-6.071-5.786-6.103 5.845a.83.83 0 0 1-1.18-.025.827.827 0 0 1 .025-1.175"
    }, null, -1)
  ]))]))
}
export default { render: render }